import { SvgIcon } from '@mui/material';

import type { BaseIconProps } from '../types';

export const CallOutlinedIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 40 40" fillRule="evenodd" stroke="none" {...props}>
      <path
        d="M33.2676 28.1363C31.6102 27.7255 29.9241 27.4405 28.2238 27.2838C26.9453 27.1544 25.7747 26.9979 24.7714 27.996L20.5097 32.2583C15.0113 29.4621 10.5422 24.9924 7.74644 19.4932L12.008 15.2094C12.2966 14.8631 12.504 14.4566 12.6151 14.0197C12.7262 13.5828 12.7381 13.1265 12.65 12.6844C12.5421 11.6054 12.2886 10.5587 12.1105 9.50125C11.9411 8.45453 11.7032 7.42003 11.3985 6.40441C11.1072 5.46025 10.5893 4.41895 9.45648 4.41895H2.67024C2.15705 4.42037 1.6653 4.62491 1.30243 4.98784C0.939548 5.35077 0.735066 5.84262 0.733643 6.35587C0.733643 15.0844 4.20052 23.4553 10.3716 29.6273C16.5427 35.7992 24.9126 39.2666 33.6399 39.2666C34.1526 39.2638 34.6435 39.0588 35.0061 38.6962C35.3687 38.3335 35.5736 37.8425 35.5764 37.3297V30.548C35.547 30.0243 35.3543 29.5231 35.0253 29.1147C34.6963 28.7063 34.2476 28.4114 33.7423 28.2712C33.5867 28.2176 33.4282 28.1726 33.2676 28.1363Z"
        stroke="currentColor"
        strokeWidth="1.20414"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M16.5071 0.733887C22.5432 0.733887 28.3321 3.13207 32.6002 7.40084C36.8684 11.6696 39.2663 17.4593 39.2663 23.4962"
        stroke="currentColor"
        strokeWidth="1.20414"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M16.5071 5.98877C21.1497 5.98877 25.6022 7.8333 28.885 11.1166C32.1678 14.3999 34.0121 18.8529 34.0121 23.4962"
        stroke="currentColor"
        strokeWidth="1.20414"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M16.5071 11.2329C19.7591 11.2329 22.8778 12.5249 25.1773 14.8248C27.4768 17.1246 28.7687 20.2438 28.7687 23.4962"
        stroke="currentColor"
        strokeWidth="1.20414"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </SvgIcon>
  );
};
